import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useAddBohrkroneMutation,
  useCreateCharakteristischenEinwirkungenMutation,
  useCreateTraggliedMutation,
  useDeleteBohrkroneMutation,
  useDeleteCharakteristischenEinwirkungenMutation,
  useDeleteTraggliedMutation,
  useGetAllTraggliederQuery,
  useGetBohrkronenQuery,
  useGetCharakteristischenEinwirkungenAllQuery,
  useUpdateBorkroneMutation,
  useUpdateCharakteristischenEinwirkungenMutation,
  useUpdateTraggliedMutation,
} from "../../services/API/titanApi";
import {
  selectAddNewState,
  selectCurrentTable,
  setAddNewState,
  setCurrentTable,
} from "../../store/slices/dataTablesSlice";
import Bohrkronen from "../DataTables/Bohrkronen";
import CharakteristischenEinwirkungen from "../DataTables/CharacteristischeEinwirkingen";
import Kopfkonstruktion from "../DataTables/Kopfkonstruktion";
import Tragglieder from "../DataTables/Tragglieder";
import "./TablesBasePage.scss";
import { TableTitle } from "./TableTitle";

export function TablesBasePageEC7() {
  const tableTitle = useSelector(selectCurrentTable);
  const [addNewBohrkrone] = useAddBohrkroneMutation();
  const [updateBohrkrone] = useUpdateBorkroneMutation();
  const [updateTragglied] = useUpdateTraggliedMutation();
  const [createTragglied] = useCreateTraggliedMutation();
  const [createCharakteristischenEinwirkungen] = useCreateCharakteristischenEinwirkungenMutation();
  const [updateCharakteristischenEinwirkungen] = useUpdateCharakteristischenEinwirkungenMutation();

  const isNewStateOn = useSelector(selectAddNewState);
  const dispatch = useDispatch();

  const bohrkronenFunctions = {
    abort: abort,
    addNew: async (localdata) => {
      try {
        await addNewBohrkrone(localdata).unwrap();
      } catch (error) {
        console.error("in Update: ", error);
      }
      dispatch(setAddNewState(false));
    },
    update: async (localdata) => {
      try {
        await updateBohrkrone({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in updateBohrkrone: ", error);
      }
      dispatch(setAddNewState(false));
    },
    GetAll: () => {
      return useGetBohrkronenQuery();
    },
  };

  const traggliedFunctions = {
    abort: abort,
    addNew: async (localdata) => {
      try {
        await createTragglied(localdata).unwrap();
      } catch (error) {
        console.error("in Tragglieder addNew: ", error);
      }
      dispatch(setAddNewState(false));
    },
    update: async (localdata) => {
      try {
        await updateTragglied({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in updateTragglied: ", error);
      }
      dispatch(setAddNewState(false));
    },
    GetAll: () => {
      return useGetAllTraggliederQuery();
    },
  };

  const kopfKonstruktionFunctions = {
    abort: abort,
    addNew: async (localdata) => {
      try {
        await createTragglied(localdata).unwrap();
      } catch (error) {
        console.error("in Tragglieder addNew: ", error);
      }
      dispatch(setAddNewState(false));
    },
    update: async (localdata) => {
      try {
        await updateTragglied({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in updateTragglied: ", error);
      }
      dispatch(setAddNewState(false));
    },
    GetAll: () => {
      return useGetAllTraggliederQuery();
    },
  };

  const charakteristischeEinwirkungenFunctions = {
    abort: abort,
    addNew: async (localdata) => {
      try {
        await createCharakteristischenEinwirkungen(localdata).unwrap();
      } catch (error) {
        console.error("in createCharakteristischenEinwirkungen addNew: ", error);
      }
      dispatch(setAddNewState(false));
    },
    update: async (localdata) => {
      try {
        await updateCharakteristischenEinwirkungen({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in Update: ", error);
      }
    },
    GetAll: () => {
      return useGetCharakteristischenEinwirkungenAllQuery();
    },
  };

  const titlesConfig = [
    {
      title: "Tragglieder",
      component: <Tragglieder functions={traggliedFunctions} />,
      functions: traggliedFunctions,
    },

    {
      title: "Bohrkronen",
      component: <Bohrkronen functions={bohrkronenFunctions} />,
      functions: bohrkronenFunctions,
    },
    {
      title: "Kopfkonstruktion",
      component: <Kopfkonstruktion functions={kopfKonstruktionFunctions} />,
      functions: kopfKonstruktionFunctions,
    },
    {
      title: "Sicherheitsbeiwerte",
      component: (
        <CharakteristischenEinwirkungen functions={charakteristischeEinwirkungenFunctions} />
      ),
      functions: charakteristischeEinwirkungenFunctions,
    },
  ];

  const [currentComponent, setCurrentComponent] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.eurocode;
    }).component
  );

  const [currentFunctions, setCurrentFunctions] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.eurocode;
    }).functions
  );

  function abort() {
    dispatch(setAddNewState(false));
  }
  function onSelectedChanged(title) {
    dispatch(setCurrentTable({ ...tableTitle, eurocode: title }));
    setCurrentComponent(getCurrent(title).component);
    setCurrentFunctions(getCurrent(title).functions);
  }

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle.eurocode)?.component);
  }, [tableTitle.eurocode, isNewStateOn]);

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle.eurocode)?.component);
    setCurrentFunctions(getCurrent(tableTitle.eurocode)?.functions);
  }, [tableTitle]);

  function getCurrent(title) {
    let result = titlesConfig.find((item) => item.title == title) || null;
    return result;
  }

  return (
    <div className="TablesBasePage">
      <div className="container-fluid">
        <div className="table-wrapper">
          <TableTitle
            tableTitle={tableTitle.eurocode}
            titles={titlesConfig}
            functions={currentFunctions}
            onSelectedChanged={onSelectedChanged}
          />
          {currentComponent || <div>Daten tabelle noch nicht aktiv</div>}
        </div>
      </div>
    </div>
  );
}

export default TablesBasePageEC7;
